import { getDiscountData } from "@/utils/discount-service";
import { useAffiliateProvider } from "@/components/affiliate/AffiliateProvider";

const useTotalCalculator = ({ profilePlan, revisionPlan }) => {
  const { multiplier } = useAffiliateProvider();
  const { discountCode, discountPct, discountMultiplier, discountMinAmount } = getDiscountData();

  // Calculate prices and credits
  const profilePrice = profilePlan?.price || 0;
  const profileCredits = profilePlan?.credits || 0;

  const revisionsPrice = revisionPlan?.price || 0;
  const revisionsCredits = revisionPlan?.credits || 0;

  const selectedPrice = profilePrice + revisionsPrice;
  const selectedCredits = profileCredits + revisionsCredits;

  // Determine if discount applies
  const discountApplied =
    !!discountCode && (!discountMinAmount || selectedCredits >= discountMinAmount);

  // Calculate discount and affiliate credits
  const discountCredits =
    discountApplied && typeof discountMultiplier === "number" && discountMultiplier
      ? Math.round(selectedCredits * (discountMultiplier - 1))
      : 0;

  const affiliateCredits =
    !discountApplied && typeof multiplier === "number" && multiplier
      ? Math.round(selectedCredits * (multiplier - 1))
      : 0;

  // Calculate final price after discount
  const finalPrice =
    !discountApplied || typeof discountPct !== "number" || !discountPct
      ? selectedPrice
      : Math.round(selectedPrice * (1 - discountPct));

  const dollarDiscount = selectedPrice - finalPrice;

  // Calculate savings for each plan
  const getPlanSavings = (plan) => {
    if (!plan || !plan.initialPrice) {
      return 0;
    }

    let currentPrice = plan.price;
    if (dollarDiscount > 0) {
      currentPrice = currentPrice * (1 - discountPct);
    }

    return Math.round((1 - currentPrice / plan.initialPrice) * 100);
  };

  const profileSavings = getPlanSavings(profilePlan);
  const revisionSavings = getPlanSavings(revisionPlan);

  return {
    profileSavings,
    revisionSavings,
    profilePrice,
    revisionsPrice,
    discountCredits,
    affiliateCredits,
    finalPrice,
    dollarDiscount,
  };
};

export default useTotalCalculator;
